// Popup to display area name, logo, and children if provided on the map
import React from "react";
import Helper from "../../Helper";
import { Area } from "../../models/Area";
import { Equipment } from "../../models/Equipment";
import { MapObject } from "../../models/MapObject";

interface Props {
    mapObject: MapObject;
    mappable?: Area | Equipment | null;

    children?: any;
}

const MapPopup: React.FC<Props> = ({ mapObject, mappable, children }) => {
    if (!mappable) {
        return (
            <div className="flex flex-col items-center">
                <div className="text-plot-slate font-plot-oswald font-semibold text-xl">Unknown</div>
            </div>
        );
    }

    return (
        // JSX for the component goes here
        <div className="flex flex-col items-center">
            <div className="flex flex-row items-center mr-4 font-plot-oswald font-semibold text-xl text-plot-slate">
                {mappable && Helper.areaAvatar(mappable, mapObject, "2rem")}{" "}
                {mappable?.areaName || mappable?.equipmentName}
            </div>
            {children}
        </div>
    );
};

export default MapPopup;
